module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/banner-5f7d08bf5f04c7123505342ea1fb0393.png";